import { atom, useAtom } from "jotai";
import React, { useEffect, useState } from "react";
import Querying from "../../Querying";
import { setPublicationDataCorrect } from "../../utils/services/linearUserFlowService";

export const publicationDataAtom = atom<any>(undefined);

/**
 *  Properties for the publication information
 */
type LoadPublicationDataProps = {
	publicationId: number;
	publicationTotalPages: number;
	setLoaded: (isLoaded: boolean) => void;
};
/**
 * Loads all publication information needed for the analytics
 *
 * @param {function} setLoaded Checks if all the information has been loaded
 * @param {number} publicationId The id of the publication which pages we want to use
 * @returns {JSX.Element} queries for publication data
 */
export const LoadPublicationData = ({ setLoaded, publicationId,
	publicationTotalPages }: LoadPublicationDataProps) => {
	const [isPublicationDataLoaded, setPublicationDataLoaded] = useState(false);
	const [isPublicationDataCorrectLoaded, setPublicationDataCorrectLoaded] = useState(false);
	const [publicationData, setPublicationData] = useAtom(publicationDataAtom);


	useEffect(() => {
		if (isPublicationDataLoaded) {
			setPublicationDataCorrect(publicationData, publicationTotalPages,
				setPublicationDataCorrectLoaded);
		}
	}, [isPublicationDataLoaded]);

	useEffect(() => {
		if (isPublicationDataCorrectLoaded)
			setLoaded(true);
	}, [isPublicationDataCorrectLoaded]);

	return (
		<div>
			{
				<Querying publicationId={publicationId} publication={(publication) => {
					setPublicationData({
						id: publicationId,
						data: publication
					});
					setPublicationDataLoaded(true);
				}}/>
			}
		</div>
	);
};

export default LoadPublicationData;